// Períodos do Fluxo de Caixa. Datas sempre locais (nunca toISOString, que é UTC).
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const mais = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

export const PRESETS = [
  { key: "proximos30", label: "Próximos 30 dias" },
  { key: "mes", label: "Este mês" },
  { key: "mesPassado", label: "Mês passado" },
  { key: "proximos90", label: "Próximos 90 dias" },
  { key: "ano", label: "Este ano" },
  { key: "custom", label: "Personalizado" },
];

/** {inicio, fim, agrupar} do atalho. "Próximos 30 dias" começa 7 dias antes,
 *  para o gráfico mostrar de onde o saldo vem. */
export function intervalo(preset, hoje = new Date()) {
  const a = hoje.getFullYear();
  const m = hoje.getMonth();
  switch (preset) {
    case "mes": return { inicio: iso(new Date(a, m, 1)), fim: iso(new Date(a, m + 1, 0)), agrupar: "dia" };
    case "mesPassado": return { inicio: iso(new Date(a, m - 1, 1)), fim: iso(new Date(a, m, 0)), agrupar: "dia" };
    case "proximos90": return { inicio: iso(hoje), fim: iso(mais(hoje, 90)), agrupar: "semana" };
    case "ano": return { inicio: iso(new Date(a, 0, 1)), fim: iso(new Date(a, 11, 31)), agrupar: "mes" };
    default: return { inicio: iso(mais(hoje, -7)), fim: iso(mais(hoje, 30)), agrupar: "dia" };
  }
}

export const hojeIso = () => iso(new Date());
